jQuery(function ($) {
    // Nav sidebar toggle
    $(".navbar-toggler").click(function() {
        $(".page-wrapper").toggleClass("navbar-toggled");
        if (localStorage.getItem('menu-collapse') === null) {
            localStorage.setItem('menu-collapse', 'false');
        } else {
            localStorage.setItem('menu-collapse', localStorage.getItem('menu-collapse') === 'true' ? 'false' : 'true')
        }
    });

       // tooltip header
    $(function () {
        $('[data-toggle="tooltip"]').tooltip()
     });

    //nav mobile overlay toggle
    $(".nav-mobile .nav-link.more, .nav-tablet .nav-link.more").click(function() {
        setTimeout(function() {
            $(".page-wrapper .overlay").toggleClass("show");
        }, 300);
    });
});
